module.exports = function(p) {

	if(p == 'prev') {
		p = parseInt(this.pagination.activePage)-1;
	} else if(p == 'next') {
		p = parseInt(this.pagination.activePage)+1;
	}

	$('html, body').animate({
        scrollTop: $("#vueList").offset().top
    }, 200);

    this.pagination.activePage = p;

    this.getData();
}